import React from "react";
import { StyledUrgencyButton } from "./styled-components";
import { ReactComponent as PhoneIcon } from "../../assets/icons/phone.svg";

const UrgencyButton = () => {
  return (
    <StyledUrgencyButton href="#urgecyBloc">
      <PhoneIcon />
      N° d'urgence
    </StyledUrgencyButton>
  );
};

export default UrgencyButton;
